import { ReactNode } from 'react';

import { EventView, GlobalAccount, GUID, OpportunityView, PersonOrg, TaskView } from '@ndvr/customer-api';

import { HouseholdLink, OpportunityNameLink, PersonOrgNameLink, TaskNameLink } from 'widgets/NameLink';

import { SourceGuid } from './SourceGuid';

type PromptComponentType = 'householdGuid' | 'personOrgGuid' | 'eventGuid' | 'taskGuid' | 'opportunityGuid';

export type PromptComponentPart = {
    type: PromptComponentType;
    guid: string;
};

type ComponentPattern = { regex: RegExp; type: PromptComponentType };

export type PromptPart = string | PromptComponentPart;

export const householdGuidComponent = (guid: GUID<GlobalAccount>) => `[householdGuid:${guid}]`;
export const personOrgGuidComponent = (guid: GUID<PersonOrg>) => `[personOrgGuid:${guid}]`;
export const eventGuidComponent = (guid: GUID<EventView>) => `[eventGuid:${guid}]`;
export const taskGuidComponent = (guid: GUID<TaskView>) => `[taskGuid:${guid}]`;
export const opportunityGuidComponent = (guid: GUID<OpportunityView>) => `[opportunityGuid:${guid}]`;

const HOUSEHOLD_GUID_PATTERN: ComponentPattern = { regex: /\[householdGuid:([\w-]+)\]/, type: 'householdGuid' };
const PERSON_ORG_GUID_PATTERN: ComponentPattern = { regex: /\[personOrgGuid:([\w-]+)\]/, type: 'personOrgGuid' };
const EVENT_GUID_PATTERN: ComponentPattern = { regex: /\[eventGuid:([\w-]+)\]/, type: 'eventGuid' };
const TASK_GUID_PATTERN: ComponentPattern = { regex: /\[taskGuid:([\w-]+)\]/, type: 'taskGuid' };
const OPPORTUNITY_GUID_PATTERN: ComponentPattern = { regex: /\[opportunityGuid:([\w-]+)\]/, type: 'opportunityGuid' };

export const COMPONENT_PATTERNS: ComponentPattern[] = [
    HOUSEHOLD_GUID_PATTERN,
    PERSON_ORG_GUID_PATTERN,
    EVENT_GUID_PATTERN,
    TASK_GUID_PATTERN,
    OPPORTUNITY_GUID_PATTERN,
];

export const renderPromptComponent = (part: PromptComponentPart): ReactNode => {
    switch (part.type) {
        case 'householdGuid':
            return <HouseholdLink householdGUID={part.guid} />;
        case 'personOrgGuid':
            return <PersonOrgNameLink personOrgGUID={part.guid} />;
        case 'opportunityGuid':
            return <OpportunityNameLink opportunityGUID={part.guid} />;
        case 'taskGuid':
            return <TaskNameLink taskGUID={part.guid} />;
        case 'eventGuid':
            return <></>; // info: intentionally hidden from the prompt display
        default:
            return <SourceGuid guid={part.guid} dotColor="amber" />;
    }
};
